import * as React from 'react';
import { styled } from '@mui/material/styles';
import LineProgress from 'components/LineProgress';

const HeaderProgressContainer = styled('div')`
  margin-top: 24px;
  margin-bottom: 12px;

  & h5 {
    font-weight: 700;
  }
`;

type HeaderProgressProps = {
  progress: number;
  data: {
    storeName: string;
    countProducts: number;
    countProgressProducts: number;
  };
  progressLabel?: string;
  isFailed?: boolean;
};

const HeaderProgress = ({ progress, data, progressLabel, isFailed }: HeaderProgressProps) => {
  const statusName = progressLabel || 'Selesai mendownload';
  return (
    <HeaderProgressContainer>
      <h5>
        {statusName} produk dari {data.storeName}
      </h5>
      <p>
        {data.countProgressProducts} dari {data.countProducts} produk
      </p>
      <div>
        <LineProgress variant="determinate" value={progress} {...(isFailed ? { color: 'error' } : undefined)} />
      </div>
    </HeaderProgressContainer>
  );
};

export default HeaderProgress;
